import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ReviewService } from "../services/review.service";
import { UserService } from '../services/user.service';

import { fadeInUp } from '../services/animations/fadeInUp.animation'

@Component({
	selector: 'app-admin',
	templateUrl: './admin.component.html',
	animations: [fadeInUp]
})
export class AdminComponent implements OnInit {
	routeId: any;
	unactioned: any;
	unactionedSubscription: any

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private title: Title,
		private reviewService: ReviewService,
		private userService: UserService
	) {
		this.routeId = this.route.snapshot.params['page'];
		this.router.events.filter((event) => event instanceof NavigationEnd).map(() => this.route).map((route) => {
			while (route.firstChild) route = route.firstChild;
			return route;
		}).filter((route) => route.outlet === 'primary').mergeMap((route) => route.data).subscribe((event) => {
			this.routeId = this.route.snapshot.params['page'];
			if (this.routeId === 'edit-content') {
				this.title.setTitle('Edit Content | Admin');
			} else if (this.routeId === 'promo-strip') {
				this.title.setTitle('Promotion Strip | Admin');
			} else if (this.routeId === 'search-user') {
				this.title.setTitle('Search User | Admin')
			} else {
				this.title.setTitle('Moderate Reviews | Admin');
			}
		});
	}

	ngOnInit() {
		this.reviewService.getUnactioned()
		this.unactionedSubscription = this.reviewService.Unactioned.subscribe(res => {
			if (res) this.unactioned = res.json()
		})
	}

	ngOnDestroy() {
		if (this.unactionedSubscription) {
			this.unactionedSubscription.unsubscribe()
		}
	}

	logout() {
		this.userService.logout();
	}

	exportCSV() {
		this.userService.exportCSV().then( (res: any) => {
			location = res.url
		})
	}

}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts